import { COLUMN_TYPES } from './constants';
import moment from 'moment';

const getNestedValue = (obj, pathStr) =>
  pathStr?.split('.').reduce((acc, part) => acc?.[part], obj);

export const createSorter = (dataIndex, config) => {
  if (!config) return null;
  const { type, path, format } = config;

  switch (type) {
    case COLUMN_TYPES.NUMBER:
      return (a, b) => (a[dataIndex] || 0) - (b[dataIndex] || 0);
    case COLUMN_TYPES.STRING:
      return (a, b) => (a[dataIndex] || '').localeCompare(b[dataIndex] || '');
    case COLUMN_TYPES.DATE:
      return (a, b) => {
        const toMs = val => {
          if (!val) return 0;
          if (typeof val.toMillis === 'function') return val.toMillis();
          if (val.seconds !== undefined) return val.seconds * 1000 + (val.nanoseconds || 0) / 1e6;
          if (val._seconds !== undefined) return val._seconds * 1000 + (val._nanoseconds || 0) / 1e6;
          return moment(val, format).valueOf();
        };
        return toMs(a[dataIndex]) - toMs(b[dataIndex]);
      };
    case COLUMN_TYPES.ARRAY_LENGTH:
      return (a, b) => (a[dataIndex]?.length || 0) - (b[dataIndex]?.length || 0);
    case COLUMN_TYPES.NESTED:
      return (a, b) => {
        const aVal = getNestedValue(a[dataIndex], path);
        const bVal = getNestedValue(b[dataIndex], path);
        if (typeof aVal === 'string') return (aVal || '').localeCompare(bVal || '');
        return (aVal || 0) - (bVal || 0);
      };
    default:
      return null;
  }
};

/**
 * Sorts rows the way a sortable `ResponsiveTable` does. Lists that page before handing rows to
 * the table sort the whole list with this, so the order across pages matches the order within one.
 * Returns `rows` itself when there is nothing to sort by.
 */
export const sortRows = (rows, columns, sortState) => {
  if (!sortState?.key || !sortState?.order) return rows;

  const column = columns.find(col => col.dataIndex === sortState.key || col.key === sortState.key);
  if (!column?.sortConfig) return rows;

  const sorter = createSorter(column.dataIndex || column.key, column.sortConfig);
  if (!sorter) return rows;

  const sorted = [...rows].sort(sorter);
  return sortState.order === 'desc' ? sorted.reverse() : sorted;
};

export default createSorter;
